export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '车牌号',
                value: 'vehicleCard',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '发车时间',
                value: 'dispatchTime',
                type: 'time',
                unfold: true,
                span: 4,
                timeNum: 6,
                startPlaceholder: '发车开始时间',
                endPlaceholder: '发车结束时间'
            },
            {
                name: '分公司',
                value: 'companyName',
                unfold: true,
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode'],
                span: 3
            },
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', 'value': '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                advanceCascade: 'companyCode',
                type: 'advance',
                span: 3
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 150,
        selectBtn: true,
        columns: [
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 180
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 180
            },
            {
                label: '发车时间',
                prop: 'dispatchTime',
                sort: true,
                width: 180
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 180
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 180
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 180
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '专业公司',
                prop: 'professionalCompany',
                sort: true,
                width: 180
            },
            {
                label: '客户名称',
                prop: 'customerNames',
                sort: true,
                width: 180
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                sort: true,
                width: 140
            },

            {
                label: '车型',
                prop: 'equipmentName',
                sort: true,
                width: 140
            },
            {
                label: '司机姓名',
                prop: 'driver',
                sort: true,
                width: 140
            },
            {
                label: '司机手机号码',
                prop: 'driverContactWay',
                sort: true,
                width: 140
            },
            {
                label: '入网状态',
                prop: 'isNet',
                sort: true,
                width: 140
            },
            {
                label: '入网确认时间',
                prop: 'netConfirmDate',
                sort: true,
                width: 180
            },
            {
                label: '最新定位时间',
                prop: 'lastLocationDate',
                sort: true,
                width: 180
            },
            {
                label: '掉线时长(min)',
                prop: 'dropTime',
                sort: true,
                width: 180
            },
            {
                label: '最后位置',
                prop: 'lastTrackingLocation',
                sort: true,
                width: 180
            },
            {
                label: '跟踪方式',
                prop: 'lastTrackingSource',
                sort: true,
                width: 180
            },
            {
                label: '最后跟踪时间',
                prop: 'lastTrackingDate',
                sort: true,
                width: 180
            },
            {
                label: '预警提示',
                prop: 'warningPrompt',
                sort: true,
                width: 180
            },
            {
                label: '严重预警',
                prop: 'severeWarning',
                sort: true,
                width: 180
            },
            {
                label: '掉线时长类型',
                prop: 'dropType',
                sort: true,
                width: 220
            },
            {
                label: '线路',
                prop: 'lineName',
                sort: true,
                width: 180
            }
        ],
        action: [
            {
                type: 'text',
                label: '查看轨迹',
                size: 'small',
                event: 'viewTrack',
                ifHas: 'otp04200002'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [
        {
            name: '专业公司',
            value: 'professionalCompany',
            type: 'select',
            optionNum: 'SYS_PROFESSIONAL_COMPANY'
        },
        {
            name: '发运类型',
            value: 'shippingType',
            optionNum: 'TMS_SHIPPING_TYPE',
            type: 'select'
        },
        {
            name: '严重预警',
            value: 'severeWarningType',
            type: 'select',
            optionNum: 'SERVER_WARNING_TYPE',
            options: []
        },
        {
            name: '客户',
            value: 'customerName',
            type: 'advance',
            unfold: true,
            multiple: true,
            maxSelect: 5,
            border: true,
            dialogWidth: '800px',
            multipleTableColumn: {
                prop: 'ebcuNameCn', 'value': '客户名称'
            },
            advanceConfig: [
                { prop: 'ebcuNameCn', value: '客户名称' },
                { prop: 'pmCode', value: '客户编码' }
            ],
            tableConfig: [
                { prop: 'pmCode', value: '客户编码' },
                { prop: 'ebcuNameCn', value: '客户名称' }
            ],
            advanceUrl: '/ebCustomer/searchByEbCustomer',
            cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
        }
    ],
    'pickerConfig': {
        'shortcuts': [
            { 'type': 'd', 'num': 2, 'text': '最近三天', 'translate': 'component.E202007300011' },
            { 'type': 'd', 'num': 6, 'text': '最近一周', 'translate': 'component.E202007300011' },
            { 'type': 'M', 'num': 1, 'text': '最近一个月', 'translate': 'component.E202007300013' }
        ]
    }
};
